import React, { RefObject, useEffect, useRef, useState } from "react";
import { Button, Icon, Modal, Form } from "semantic-ui-react";
import ModalEditImage from "react-lib/apps/common/ModalEditImage";
import FaceRecordUX from "./FaceRecordUX";
import ModifiedMallampati from "./ModifiedMallampati";
import ExaminationImageOverlay, { Tooltip } from "./ExaminationImageOverlay";

import FaceExamUX from "../FaceExamUX";

const FACE = "Head & Neck";

const FaceRecord = (props) => {
  const [openGallery, setOpenGallery] = useState(false);
  const [openPhysicalExam, setOpenPhysicalExam] = useState(false);

  let tooltipRef = useRef() as any;
  const handleClick = (key) => () => {
    // console.log("handleClick key: ", key)
    if (props.selectorMode) {
      const organMaster = props.masterData?.organ?.items.filter((item) => item.hasOwnProperty("settingKey"));
      // console.log(" handleClick organMaster ", organMaster)
      let organ = organMaster.filter((item) => item.settingKey === key);
      // console.log(" handleClick organ ", organ)

      if (organ.length === 1) {
        props.onEvent({ message: "ToggleLocation", params: { items: [{ location: organ[0].nickName }] } });
      } else {
        console.error(" should not see me.");
      }
    }
  };

  const handleMouseOver = (e, key) => {
    tooltipRef?.show?.({
      target: e.target,
      key,
      masterData: props.masterData,
      selector: ".head-neck-area.svg-zoom-out",
    });
  };

  const handleMouseLeave = () => {
    tooltipRef.current.style.display = "none";
  };

  let settings = Object.assign({}, defaultSettings);
  // console.log(props.clinicalFindings)
  const clinicalTagsItems = props.masterData.clinicaltags?.items;
  const organMaster = props.masterData?.organ?.items.filter((item) => item.hasOwnProperty("settingKey")); // เอาสิ่งที่ไม่ใช่ ฟัน
  const clinical = props.clinicalFindings.find((item) => item.id === props.clinicalFindingId);
  const targetLocation = clinical?.location?.split(",").map((item) => item.trim()) || [];
  const targetClinicaltags = clinical?.clinicaltags?.split(",").map((item) => item.trim()) || [];
  const findClinicalTag = clinicalTagsItems?.find((data) => targetClinicaltags.includes(data.name) && data.diagram === "noteeth");
  let previousList: any[] = [];

  // console.log('props ', props);
  // console.log('clinical: ', clinical);
  // console.log('findClinicalTag: ', findClinicalTag);

  // console.log("OrganMaster ", organMaster)
  for (const item of props.clinicalFindings) {
    let locationList = item?.location?.split(",").map((item) => item.trim()) || [];
    let clinicaltagsList = item?.clinicaltags?.split(",").map((item) => item.trim()) || [];
    for (const keyNickName of locationList) {
      let organ = organMaster.filter((item) => item.nickName === keyNickName);

      if (organ?.length > 0) {
        organ.forEach((element) => {
          let color = "transparent";
          //key ตรงกับ clinical ที่ active อยู่
          if (findClinicalTag && targetLocation?.includes(keyNickName)) {
            // color = findClinicalTag.color[0];
            color = getClinicalTagColor(clinicalTagsItems, targetClinicaltags);
          } else if (targetLocation?.includes(keyNickName)) {
            color = "orange";
          }

          // console.log("findClinicaltags1", settings[element.settingKey]);

          if (!props.clinicalFindingId) {
            const findClinicaltags = clinicalTagsItems?.find((data: any) => clinicaltagsList.includes(data.name) && data.diagram === "noteeth");

            console.log("findClinicaltags", color, findClinicaltags, previousList, keyNickName, element.settingKey);

            if (findClinicaltags) {
              const data = getClinicalTagMergeColor({
                clinicalTagsItems,
                clinicaltagsList,
                previousList,
                findClinicaltags,
                keyNickName,
                color,
              });

              color = data.color;
              previousList = data.previousList;

              // const findIndex = previousList.findIndex((prev) => prev.location === keyNickName);
              // color = findClinicaltags.color[0];
              // //keyNickName ไม่มีใน location ก่อนหน้า
              // if (findIndex !== -1) {
              //   if (findClinicaltags.name !== previousList[findIndex].tag.name) {
              //     // const inflamAndInfec = props.masterData.clinicaltags?.items?.find(
              //     //   (data) => data.name === "Inflammation & infection" && data.diagram === "noteeth"
              //     // );
              //     color = findClinicaltags.color[0];
              //     previousList[findIndex].tag = findClinicaltags;
              //   }
              // } else {
              //   previousList.push({
              //     location: keyNickName,
              //     tag: findClinicaltags,
              //   });
              // }
            } else if (locationList?.includes(keyNickName)) {
              color = "orange";
            }
          }

          settings[element.settingKey] = {
            ...settings[element.settingKey],
            fill: color,
            opacity: "0.7",
          };
        });
      }

      // if (organ.length > 0 ) {
      //   // if (Object.keys(defaultSettings).includes(keyNickName)) {

      //       settings[organ[0].settingKey] = {
      //         ...settings[organ[0].settingKey],
      //         fill: "orange",
      //         opacity: "0.7"
      //       }

      //   // }
      // }
    }
  }

  for (const key in defaultSettings) {
    if (Object.prototype.hasOwnProperty.call(defaultSettings, key)) {
      settings[key] = {
        ...settings[key],
        onClick: handleClick(key),
        style: { pointerEvents: "auto" },
        onMouseOver: (e) => {
          handleMouseOver(e, key);
        },
        onMouseLeave: (e) => {
          handleMouseLeave(e, key);
        },
      };
    }
  }

  // console.log("settings", settings)

  return (
    <div
      // className="facerecord-area"
      style={{ ...{ cursor: props.selectorMode ? "cell" : "default" }, padding: "0px 0px", display: "flex" }}
      onMouseDown={(e: any) => {
        if (props.selectorMode) {
          e.preventDefault();
        }
      }}
    >
      <Form>
        <div className="head-neck-area svg-zoom-out">
          <ExaminationImageOverlay
            imageKey="face"
            sub={props.sub}
            historyReviewSubTab={props.historyReviewSubTab}
            clinicalFindings={props.clinicalFindings}
            filterClinicalFindingIds={props.filterClinicalFindingIds}
            showDrawingChecked={props.showDrawingChecked}
            hideTooltip={true}
            firstPosition={true}
            width="900"
            height="400"
          >
            <FaceRecordUX settings={settings} />
          </ExaminationImageOverlay>
        </div>
      </Form>

      <Tooltip ref={(ref) => (tooltipRef = ref || { current: null })} />

      {/* <ModifiedMallampati hiddenEvaluation={props.hiddenEvaluation? props.hiddenEvaluation : false}/> */}

      {props.activeEvaluation ? (
        <Modal
          onClose={() => props.setProp("activeEvaluation", "")}
          // onOpen={() => setOpenPhysicalExam(true)}
          open={props.activeEvaluation === FACE}
          className="modal-face-exam"
        >
          {" "}
          <FaceExamUX
            faceExamData={props.faceExamData}
            onEvent={props.onEvent}
            setProp={props.setProp}
            handleSaveFaceExam={() => {
              // console.log(props.faceExamData)
              props.onEvent({ message: "SaveEvaluationForm", params: { form: "faceExamData" } });
              // props.setProp("faceExamData", {})
              props.setProp("activeEvaluation", "");
            }}
          />{" "}
        </Modal>
      ) : null}
    </div>
  );
};

const groupClinicaltags = (items: any[]) => {
  let groups = items.reduce((result: any, item: any) => {
    if (item.is_group && !result.get(item.group)) {
      result.set(item.group, []);
    }
    if (result.get(item.group)) {
      result.set(item.group, result.get(item.group).concat(item));
    }
    return result;
  }, new Map());

  return groups;
};

export const getClinicalTagColor = (clinicaltagsItems: any[], targetClinicaltags: string[]) => {
  const groups = groupClinicaltags(clinicaltagsItems);
  const groupList = [...groups];
  const keys: string[] = groupList.flatMap(([key, items]) => (items.find((item: any) => item.diagram === "noteeth") ? items.map((acc: any) => acc.name) : []));
  const firstTag = targetClinicaltags.find((tag) => keys.includes(tag));

  const findGroup = groupList?.find(([key, items]) =>
    items.find(
      (item: any) =>
        // targetClinicaltags.includes(item.name)
        firstTag === item.name && item.diagram === "noteeth"
    )
  )?.[1]?.[0];

  return findGroup?.color?.[0] || "";
};

export const getClinicalTagMergeColor = (data: {
  clinicalTagsItems: any[];
  clinicaltagsList: string[];
  previousList: any[];
  keyNickName: string;
  color: string;
  findClinicaltags: any;
}) => {
  let { color, clinicalTagsItems, keyNickName, previousList, clinicaltagsList, findClinicaltags } = data;

  const findIndex = previousList.findIndex((prev) => prev.location === keyNickName);
  color = getClinicalTagColor(clinicalTagsItems, clinicaltagsList);
  //keyNickName ไม่มีใน location ก่อนหน้า
  if (findIndex !== -1) {
    if (findClinicaltags.name !== previousList[findIndex].tag.name) {
      // const inflamAndInfec = props.masterData.clinicaltags?.items?.find(
      //   (data) => data.name === "Inflammation & infection" && data.diagram === "noteeth"
      // );
      color = getClinicalTagColor(clinicalTagsItems, clinicaltagsList);
      previousList[findIndex].tag = findClinicaltags;
    }
  } else {
    previousList.push({
      location: keyNickName,
      tag: findClinicaltags,
    });
  }

  return { color, previousList };
};

export default FaceRecord;

const defaultSettings = {
  face1: { fill: "transparent", stroke: "green" },
  face2: { fill: "transparent", stroke: "green" },
  face3: { fill: "transparent", stroke: "green" },
  face4: { fill: "transparent", stroke: "green" },
  face5: { fill: "transparent", stroke: "green" },
  face6: { fill: "transparent", stroke: "green" },
  face7: { fill: "transparent", stroke: "green" },
  face8: { fill: "transparent", stroke: "green" },
  face9: { fill: "transparent", stroke: "green" },
  face10: { fill: "transparent", stroke: "green" },
  face11: { fill: "transparent", stroke: "green" },
  face12: { fill: "transparent", stroke: "green" },
  face13: { fill: "transparent", stroke: "green" },
  face14: { fill: "transparent", stroke: "green" },
  face15: { fill: "transparent", stroke: "green" },
  face16: { fill: "transparent", stroke: "green" },
  face17: { fill: "transparent", stroke: "green" },
  face18: { fill: "transparent", stroke: "green" },
  face19: { fill: "transparent", stroke: "green" },
  face20: { fill: "transparent", stroke: "green" },
  face21: { fill: "transparent", stroke: "green" },
  face22: { fill: "transparent", stroke: "green" },
  face23: { fill: "transparent", stroke: "green" },

  face25: { fill: "transparent", stroke: "green" },
  face26: { fill: "transparent", stroke: "green" },
  face27: { fill: "transparent", stroke: "green" },
  face28: { fill: "transparent", stroke: "green" },

  face30: { fill: "transparent", stroke: "green" },
  face31: { fill: "transparent", stroke: "green" },
  face32: { fill: "transparent", stroke: "green" },
  face33: { fill: "transparent", stroke: "green" },
  face34: { fill: "transparent", stroke: "green" },
  face35: { fill: "transparent", stroke: "green" },
};

// frontLeft: { fill: "transparent", stroke: "green" },
// frontRight: { fill: "transparent", stroke: "green" },
// sideLeft: { fill: "transparent", stroke: "green" },
// sideRight: { fill: "transparent", stroke: "green" },
// backLeft: { fill: "transparent", stroke: "green" },
// backRight: { fill: "transparent", stroke: "green" },
